import React from 'react';
import { motion } from 'framer-motion';
import { constitutionalControls } from '../../data/semanticKnowledge';
import { fadeUp } from '../../utils/motion';
export function SkpControls() {
  return <section className="bg-navy-deep text-white py-20 lg:py-28" data-id="element-1919" data-mp="3f3m173bziwyf">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1920" data-mp="3f19j8q688mld">
        <motion.div {...fadeUp} className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-16 mb-16" data-id="element-1921" data-mp="3k0vvawabjwsl">
          <h2 className="lg:col-span-5 font-heading font-bold text-4xl lg:text-5xl tracking-tight leading-tight" data-id="element-1922" data-mp="364s7pltyamp3">
            Constitutional controls by design
          </h2>
          <p className="lg:col-span-7 text-xl text-white/80 leading-relaxed" data-id="element-1923" data-mp="2w5sx3xpmkgzg">
            The Cognarchism founding charter calls for evaluative systems that
            are auditable and reviewable, with notice of adverse grounds,
            rights of appeal and correction, and pathways to restoration. SKP
            is designed to make those requirements technically enforceable.
          </p>
        </motion.div>

        <motion.dl {...fadeUp} className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-12 border-t border-white/15" data-id="element-1924" data-mp="3cpoiet9vixuu">
          {constitutionalControls.map(control => <div key={control.title} className="border-b border-white/15 py-8" data-id="element-1925" data-mp="3llxm4k4vwims">
              <dt className="font-heading font-bold text-xl mb-2" data-id="element-1926" data-mp="3hkm2cv8oyrmi">{control.title}</dt>
              <dd className="text-white/70 leading-relaxed" data-id="element-1927" data-mp="2ttgkkaj6xp9k">{control.body}</dd>
            </div>)}
        </motion.dl>

        <motion.div {...fadeUp} className="mt-14 border border-white/20 rounded-lg p-8 lg:p-10 max-w-4xl" data-id="element-1928" data-mp="2ow6q2ggy2nev">
          <p className="text-lg text-white leading-relaxed mb-4" data-id="element-1929" data-mp="2xu8vr9bmi48h">
            The platform can administer these controls; it cannot make an
            unvalidated assessment fair simply by recording it.
          </p>
          <p className="text-white/70 leading-relaxed" data-id="element-1930" data-mp="d3hu5ukjk7i8">
            Any proposed use of NCJI for role qualification or civic access
            requires evidence that its measures are fit for that use and
            procedures that allow meaningful human challenge.
          </p>
        </motion.div>
      </div>
    </section>;
}